export default __webpack_public_path__ + "static/media/reports-15.cba6d4b0.png";